import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Modal, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';
// import ActivityLog from '../ActivityLog';

const Accept_interbranch = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("");

    const [headerData, setHeaderData] = useState([]);
    const [innerData, setInnerData] = useState([]);

    const [isMsgBox, setMsgBox] = useState(false);
    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [isErrBox, setErrBox] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [msgText, setMsgText] = useState("");
    const [errText, setErrText] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [showModalView, setShowModalView] = useState(false);

    const [radioType, setRadioType] = useState('L');
    const [listRadioType, setListRadioType] = useState('L');
    const [acceptIBLocation, setAcceptIBLocation] = useState(null);
    const [fromLocationCN, setFromLocationCN] = useState("")//C for code and N for name
    const [toLocation, setToLocation] = useState("");
    const [toLocationCode, setToLocationCode] = useState(0);
    const [locationCode, setLocationCode] = useState(0);
    const [acceptIBFromDate, setAcceptIBFromDate] = useState(new Date());
    const [acceptIBToDate, setAcceptIBToDate] = useState(new Date());
    const [acceptIBStatus, setAcceptIBStatus] = useState('');
    const [acceptIBDate, setAcceptIBDate] = useState(new Date());
    const [srNo, setSrNo] = useState(0);
    const [outLogSrno, setOutLogSrno] = useState(0);
    const [type, setType] = useState("");//VTMOUT,IB,CNOUT,CHQOUT
    const [groupCode, setGroupCode] = useState(0);
    const [accountCode, setAccountCode] = useState(0);
    const [acceptIBTotalAmount, setAcceptIBTotalAmount] = useState(0);
    const [fromLocation, setFromLocation] = useState(0);
    const [viewDateUnloc, setViewDateUnloc] = useState(false);

    const [unlockRequestType, setUnlockRequestType] = useState("");

    const [viewStatus, setViewStatus] = useState();
    const [viewObject, setViewObject] = useState();
    const [narration, setNarration] = useState('')
    const [outCNExecutive, setOutCNExecutive] = useState(null);
    const [executive, setExecutive] = useState(0);
    const [ndeliveryBy, setNdeliveryBy] = useState("");
    const [shipmentNumber, setShipmentNumber] = useState("");
    const [ledgerValue, setLedgerValue] = useState('');
    const [changedAccountArray, setChangedAccountArray] = useState([]);
    const [activityDate, setActivityDate] = useState('')
    const [cardType, setCardType] = useState("");
    // const [showActivityLog, setShowActivityLog] = useState(false);
    // const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });






    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setAcceptIBLocation(response);
                response != null && handleChangeLocation(response);
            });

            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_ACCEPT_BRANCH'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setAcceptIBLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setFromLocationCN(value.value);
        setHeaderData([]);
        sessionStorage.activeBranch = loc[1];
    }

    const list = () => {
        debugger
        if (radioType === 'L' && acceptIBLocation === null) {
            setMsgText("Please Select Location!");
            setMsgBox(true);
        } else {
            $(".loader").show();
            const obj = {
                filterRadioType: radioType,
                filterLocation: locationCode,
                filterFromDate: Common.dateYMD(acceptIBFromDate),
                filterToDate: Common.dateYMD(acceptIBToDate),
                filterStatus: acceptIBStatus,
            }
            Common.callApi(Common.apiAcceptInterBranch, [sid, 'list', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                setListRadioType(radioType);
                let resp = JSON.parse(result);
                setHeaderData([...resp]);
                console.log('list', resp);
                setScrMode('');
            });
        }
    }

    const viewList = (res) => {
        setViewObject(res);
        // if (res?.tol_from_type === 'CHQOUT') {
        setFromLocationCN(res.tol_from_location);//CN stand for code and name
        setToLocation(res.tolocation);
        setOutLogSrno(res.tol_srno);
        setSrNo(res.tol_from_srno);
        setType(res.tol_from_type);
        setGroupCode(res.hdr_group);
        setAccountCode(res.hdr_ledger);
        // setAcceptIBTotalAmount(res.hdr_forex_total);
        setFromLocation(res.tcb_location);
        setShowModalView(true);
        setViewStatus(res.tol_status);
        setNarration(res.tfh_narration);
        setNdeliveryBy(res.hdr_delivery_by);
        setActivityDate(res.tol_from_date)
        const obj = {
            srno: res.tol_from_srno,
            type: res.tol_from_type,
            location: res.tol_to_loc,
            fromLocation: res.tol_from_location.split(' ')[0]
        }
        Common.callApi(Common.apiAcceptInterBranch, [sid, 'view', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setScrMode('Q')
            setInnerData(resp);
            // setExecutive(resp.hdr_executive);
            if (res.tol_from_type === 'CNOUT') {
                let sum = 0;
                resp.forEach(element => {
                    sum += element.prd_amount * 1
                });
                setAcceptIBTotalAmount(sum);
            }
        });
        // } 
    }


    // const handleAccept = (res) => {
    //     setShowModal(true);
    //     setSrNo(res.tol_from_srno);
    //     setToLocationCode(res.tol_to_loc);
    //     setType(res.tol_from_type);
    //     setGroupCode(res.hdr_group)
    //     setAccountCode(res.hdr_ledger);
    //     setFromLocation(res.tol_from_loc);
    // }

    const handleAccept = (res) => {
        // setLocationCode(location);
        setShipmentNumber("");
        setShowModalView(false)
        setShowModal(true);
        setAcceptIBDate(new Date());
        setSrNo(res.tol_from_srno);
        setOutLogSrno(res.tol_srno);
        // setLocationCode(location);
        setToLocationCode(res.tol_to_loc);
        setGroupCode(res.hdr_group);
        setFromLocation(res.tol_from_loc);
        setAccountCode(res.hdr_ledger);
        setType(res.tol_from_type);
        setNarration(res.tfh_narration);
        setNdeliveryBy(res.hdr_delivery_by);
        setActivityDate(res.tol_from_date)
    }
    // code to accept one by one line number.
    // function handleAcceptOneByOne(res) {
    //     console.log(res)
    //     setViewDateUnloc(res.new_date);
    //     const dateA = new Date(res.new_date);
    //     const dateB = new Date(Common.dateYMD(new Date()));
    //     const differenceInMilliseconds = dateB - dateA;
    //     // Convert milliseconds difference to days
    //     console.log(differenceInMilliseconds);
    //     const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
    //     const obj1 = {
    //         srno: srNo,
    //         type: res.tcb_type,
    //         pageright: 'TRAN_ACCEPT_BRANCH'
    //     }
    //     console.log(differenceInDays);
    //     console.log(Common.editDateLimit);
    //     Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj1)], (result) => {
    //         let resp = JSON.parse(result);
    //         if (Common.editDateLimit == differenceInDays || resp == "unlock") {
    //             setShowModal(true);
    //             // setSrNo(res.tol_from_srno);
    //             // setLocationCode(location);
    //             setToLocationCode(res.tol_to_loc);
    //             setGroupCode(res.tcb_group);
    //             setFromLocation(fromLocation);
    //             setAccountCode(res.tcb_account);
    //             setType(res.tcb_type);
    //         } else {
    //             alert("Transaction is locked.");
    //         }
    //     });
    // }
    // shipmentNumber === "" ||
    const handleChanges = () => {
        $('.loader').show();
        if ((type === 'CNOUT' && (!executive)) || (type === 'CNOUT' && ndeliveryBy === 'A' && shipmentNumber === "")) {
            setShowModal(false)
            setMsgText("Please Fill Executive or Shipment Number .");
            setMsgBox(true);
            $('.loader').hide();
            return;
        }
        const obj1 = {
            srno: srNo,
            type: type,
            pageright: 'TRAN_ACCEPT_BRANCH',
            location: locationCode,
            acceptdate: Common.dateYMD(acceptIBDate)
        }
        const currDate = new Date();

        const newViewDate = Common.dateYMD(acceptIBDate);
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // const dateA = new Date(res.new_date);
        // const dateB = new Date(Common.dateYMD(new Date()));
        const differenceInMilliseconds = dateB - dateA;
        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj1)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit >= differenceInDays || resp.msg == "unlock") {
                const obj = {
                    location: locationCode,
                    type: type,
                    srno: srNo,
                    date: Common.dateYMD(acceptIBDate),
                    toLocation: toLocationCode,
                    groupCode: groupCode,
                    accountCode: accountCode,
                    fromLocation: fromLocation,
                    narration: narration,
                    tranOutLogSrno: outLogSrno,
                    executive: executive,

                    filterRadioType: radioType,
                    filterLocation: locationCode,
                    filterFromDate: Common.dateYMD(acceptIBFromDate),
                    filterToDate: Common.dateYMD(acceptIBToDate),
                    filterStatus: acceptIBStatus,
                    shipmentNumber: shipmentNumber,
                    changedAccountArray: changedAccountArray,
                }
                Common.callApi(Common.apiAcceptInterBranch, [sid, 'save', JSON.stringify(obj)], (result) => {
                    $('.loader').hide();
                    let resp = JSON.parse(result);
                    if (resp.status) {
                        setScrMode('')
                        setHeaderData(resp.list);
                        setShowModalView(false);//it will close list modal
                        setShowModal(false);
                    } else {
                        setMsgText(resp.msg);
                        setMsgBox(true);
                    }
                });
                setShowModal(false);
            } else {
                $('.loader').hide();
                setShowModal(false);
                setShowModalView(false);
                setMsgBox(true);
                setMsgText("Transaction locked.");
            }
        });

    }


    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }

    const handleExecutiveChange = (value) => {
        setOutCNExecutive(value);
        const exe = value.id.split('^');
        setExecutive(exe[1]);
    }

    const handleLedgerValue = (value, obj1, index) => {
        // const value = e.target.value;
        const a = innerData.map((item, i) => i === index ? { ...item, ledgerValue: value } : item);
        console.log(a);
        setInnerData(a)
        const account = value?.id?.split('^');
        const obj = {
            lineno: obj1?.tfd_line_no || 0,
            groupCode: account[1],
            accountCode: account[2],
        }
        // setChangedAccountArray((prev) => [...prev, obj]);
        setChangedAccountArray((prev) => {
            const exists = prev.some(item => item.lineno === obj1.lineno);
            if (exists) {
                return prev.map(item => item.lineno === obj1.lineno ? obj : item);
            } else {
                return [...prev, obj];
            }
        });
        console.log(changedAccountArray)
    }

    const clearAccount = (obj, index) => {
        innerData[index].ledgerValue = null;
        setInnerData([...innerData]);
        setChangedAccountArray((prev) => prev.filter((item) => item.lineno !== obj.lineno));
        console.log(changedAccountArray)

    };

    function closeHandler() {
        setShowModalView(false);
        setScrMode('')
        setActivityDate('')
    }
    // const btnActivityLog = () => {
    //     setShowActivityLog(true);
    //     setLogObject({ trantype: type, trannumber: srNo, trancategory: "T", location: locationCode });
    // }


    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Accept Inter Branch</h2>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {scrMode === '' ?
                    <>
                        <Row>
                            <Col className='col-md-4 col-6'>
                                <Form.Group>
                                    <Row style={{ marginTop: "30px" }}>
                                        <Col>
                                            <Form.Check checked={radioType === "L"} onChange={() => setRadioType("L")} type='radio' label="Location" />
                                        </Col><Col>
                                            <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                        </Col><Col>
                                            <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="Status" />
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            {
                                radioType === 'L' ?
                                    <>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={acceptIBLocation}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleChangeLocation}
                                                    isDisabled={branchDisable === "true"}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                    </> :
                                    radioType === 'D' ?
                                        <>

                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={acceptIBFromDate}
                                                        onChange={(date) => setAcceptIBFromDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={acceptIBToDate}
                                                        onChange={(date) => setAcceptIBToDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </> :
                                        radioType === 'S' ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Status<span className="text-danger">*</span></Form.Label>
                                                        <Form.Select value={acceptIBStatus} onChange={e => setAcceptIBStatus(e.target.value)}
                                                            required>
                                                            <option value="">All</option>
                                                            <option value="P">Pending</option>
                                                            <option value="D">Done</option>
                                                        </Form.Select>
                                                    </Form.Group>
                                                </Col>
                                            </> : null
                            }
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={list}>List</Button>
                            </Col>
                        </Row>
                        <Row>&nbsp;</Row>
                        <Row>
                            <Col>
                                <Table striped bordered hover size="sm">
                                    <thead>
                                        <tr>
                                            {userRight.edit === "1" ? <th></th> : null}
                                            <th>Activity Date</th>
                                            <th>From</th>
                                            <th>To</th>
                                            <th>Date</th>
                                            <th>Type</th>
                                            <th>SrNo</th>
                                            <th>Amount</th>
                                            <th>Status </th>
                                            {userRight.edit === "1" ? <th></th> : null}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            headerData.map((res, index) => (
                                                <tr key={index}>
                                                    {userRight.query === "1" ?
                                                        <td align='center'>
                                                            <span className="handCursor colorThemeBlue" onClick={() => viewList(res)}>
                                                                <FontAwesomeIcon icon={faEye} />
                                                            </span>
                                                        </td>
                                                        : null
                                                    }
                                                    <td>{res.tol_timestamp}</td>
                                                    <td>{res.tol_from_location}</td>
                                                    <td>{res.tol_to_location}</td>
                                                    <td>{res.tol_from_date}</td>
                                                    <td>{res.tol_from_type}</td>
                                                    <td>{res.tol_from_srno}</td>
                                                    <td>{res.prd_amt}</td>
                                                    <td>{res.tol_status === 'P' ? 'Pending' : res.tol_status === 'R' ? 'Rejected' : 'Done'}</td>
                                                    <td align='center'>
                                                        {res.tol_status === 'P' && listRadioType === 'L' ?
                                                            <span> <Button variant='primary' size='sm' onClick={() => handleAccept(res)}>Accept</Button>  </span> :
                                                            null
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </> : <>
                        <Row show={showModalView} onHide={() => setShowModalView(false)} animation={false} centered>
                            <Row>
                                <Container fluid>
                                    {/* <Row>
                                        <Col>
                                            {(userRight.edit === "1" && scrMode === 'Q') ? <>
                                                <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnActivityLog()}>Activity Log</Button>&nbsp;
                                            </> :
                                                null
                                            }
                                        </Col>
                                    </Row> */}
                                    <Row>
                                        <Col className='col-md-4 col-6'>From Location : {fromLocationCN}</Col>
                                        <Col className='col-md-4 col-6'>To Location : {toLocation}</Col>
                                        <Col className='col-md-3 col-6'>Type : {type}</Col>
                                        <Row>
                                            <Col className='col-md-4 col-6'>Srno : {srNo}</Col>
                                            <Col className='col-md-4 col-6'>Source Transaction Date : {activityDate}</Col>
                                        </Row>

                                        {type === 'CNOUT' && viewStatus != 'P' && <Col className='col-md-3 col-6'>Executive : {innerData[0]?.hdr_executive}</Col>}
                                        {
                                            type === 'CNOUT' ?
                                                <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Total Amount</Form.Label>
                                                            <Form.Control
                                                                value={acceptIBTotalAmount}
                                                                disabled
                                                                placeholder="Total" />
                                                        </Form.Group>
                                                    </Col>
                                                </> : null
                                        }
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <Table responsive striped bordered hover>
                                                <thead>
                                                    <tr>
                                                        {
                                                            type === 'CNOUT' ?
                                                                <>
                                                                    <th>Currency</th>
                                                                    <th>Denomination</th>
                                                                    <th>Quantity</th>
                                                                    <th>Rate</th>
                                                                    <th>Amount</th>
                                                                </> :
                                                                type === 'CHQOUT' ?
                                                                    <>
                                                                        <th>Quantity</th>
                                                                        <th>From</th>
                                                                        <th>To</th>
                                                                        <th>Date</th>
                                                                        <th>Bank</th>
                                                                        {/* <th>Action</th> */}
                                                                    </> :
                                                                    type === 'IB' ?
                                                                        <>
                                                                            {/* <th>Type</th> */}
                                                                            {/* <th>Location</th> */}
                                                                            {/* <th>Date</th> */}
                                                                            <th>Group</th>
                                                                            <th>Account</th>
                                                                            <th>Account Name</th>
                                                                            <th>Debit</th>
                                                                            <th>Credit</th>
                                                                            {/* <th>KnockOff Srno</th>
                                                                    <th>KnockOff Type</th> */}
                                                                            <th>Adjusted</th>
                                                                            {/* <th>KnockOff Amount</th> */}
                                                                        </> :
                                                                        <>
                                                                            <th>Card</th>
                                                                            <th>ISD</th>
                                                                            <th>Prefix</th>
                                                                            <th>Issuer Name</th>
                                                                            <th>Quantity</th>
                                                                            <th>From</th>
                                                                            <th>To</th>
                                                                        </>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        type === 'VTMOUT' || type === 'CNOUT' || type === 'IB' ?
                                                            <>
                                                                {
                                                                    innerData.map((res, index) =>
                                                                        <>
                                                                            <tr key={res.prd_line_no}>
                                                                                {
                                                                                    type === 'VTMOUT' ?
                                                                                        <>
                                                                                            <td>{res.prd_cardtype}</td>
                                                                                            <td>{res.prd_isd}</td>
                                                                                            <td>{res.prd_prefix}</td>
                                                                                            <td>{res.mvli_ledger_name}</td>
                                                                                            <td>{res.prd_qty}</td>
                                                                                            <td>{res.prd_from}</td>
                                                                                            <td>{res.prd_to}</td>
                                                                                        </> :
                                                                                        type === 'IB' ?
                                                                                            <>
                                                                                                {/* <td>{res.tfd_type}</td> */}
                                                                                                {/* <td>{res.entity_name}</td> */}
                                                                                                {/* <td>{res.formatted_date}</td> */}
                                                                                                <td>{res.tfd_group}</td>
                                                                                                <td>{res.tfd_account}</td>
                                                                                                <td>{res.mvli_ledger_name}</td>
                                                                                                <td>{res.tfd_flag === 'D' ? res.tfd_amount : ''}</td>
                                                                                                <td>{res.tfd_flag === 'C' ? Math.abs(res.tfd_amount) : ''}</td>
                                                                                                {/* <td>{res.tfd_knockoff_srno}</td> */}
                                                                                                {/* <td>{res.tfd_knockoff_srno !== null ? res.tfd_knockoff_type : ''}</td> */}
                                                                                                <td>{res.tfd_knockoff_srno !== null ? (res.tfd_knockoff_type + ' ' + res.tfd_knockoff_srno) : ''}</td>
                                                                                                {/* <td>{res.tfd_knockoff_srno !== null ? Math.abs(res.tfd_amount) : ''}</td> */}

                                                                                            </> :
                                                                                            type === 'CNOUT' ?
                                                                                                <>
                                                                                                    <td>{res.prd_isd}</td>
                                                                                                    <td>{res.prd_deno}</td>
                                                                                                    <td>{res.prd_qty}</td>
                                                                                                    <td>{res.prd_rate}</td>
                                                                                                    <td>{res.prd_amount}</td>
                                                                                                </> : null
                                                                                }
                                                                            </tr>
                                                                            {res.mvg_type !== 'CASH' && type === 'IB' && res.tfd_flag === 'C' && viewStatus === 'P' && listRadioType === 'L' && (userRight.add === '1' || userRight.edit === '1') &&
                                                                                <tr>
                                                                                    <td colSpan={5}>
                                                                                        <Form.Group>
                                                                                            <Form.Label>Account<span className="text-danger">*</span></Form.Label>
                                                                                            <AsyncSelect
                                                                                                cacheOptions={false}
                                                                                                defaultOptions={false}
                                                                                                value={res?.ledgerValue}
                                                                                                getOptionLabel={e => e.label + ' '}
                                                                                                getOptionValue={e => e.id}
                                                                                                loadOptions={(search) => Picklist.fetchLedgerAllowedWithGroupPicklist(search, locationCode)}
                                                                                                onInputChange={Picklist.handleInputChange}
                                                                                                onChange={(e) => handleLedgerValue(e, res, index)}
                                                                                                formatOptionLabel={Picklist.accountFormatOptionLabel}
                                                                                                components={{ Menu: Picklist.accountMenu }}
                                                                                                isDisabled={res.mvg_type === 'CASH'}
                                                                                                menuPortalTarget={document.body}
                                                                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                                            >
                                                                                            </AsyncSelect>
                                                                                        </Form.Group>
                                                                                    </td>
                                                                                    <td colSpan={3} style={{ paddingTop: '2.6rem' }}>
                                                                                        <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => clearAccount(res, index)}>Clear</Button>
                                                                                    </td>

                                                                                </tr>
                                                                            }
                                                                        </>
                                                                    )
                                                                }
                                                            </> :
                                                            <>
                                                                {//this is for CHQOUT 
                                                                    innerData.map((res) =>
                                                                        <tr key={res.tcb_line_no}>
                                                                            <td>{res.tcb_quantity}</td>
                                                                            <td>{res.tcb_from}</td>
                                                                            <td>{res.tcb_to}</td>
                                                                            <td>{res.tcb_date}</td>
                                                                            <td>{res.bank}</td>
                                                                            {/* {type === 'CHQOUT' && <td align='center'> {
                                                                        res.status === 'P' ?
                                                                            <span>
                                                                                <Button variant='primary' size='sm' onClick={() => handleAcceptOneByOne(res)}>Accept</Button>
                                                                            </span> : null
                                                                    }
                                                                    </td>} */}
                                                                        </tr>
                                                                    )
                                                                }
                                                            </>
                                                    }
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                </Container>
                            </Row>
                            <Row>
                                &nbsp;
                                {type === 'IB' && <Row style={{ display: 'contents' }}> <span style={{ wordWrap: 'break-word' }}><th> Narration : </th>  {narration}</span> </Row>
                                }
                                &nbsp;
                                <Col>
                                    <Button size='sm' variant="outline-success" className='buttonStyle' onClick={() => closeHandler()}> Back  </Button>
                                    &nbsp;
                                    {viewStatus === 'P' && listRadioType === 'L' && (userRight.add === '1' || userRight.edit === '1') &&
                                        <span> <Button variant='primary' className='buttonStyle' size='sm' onClick={() => handleAccept(viewObject)}>Accept</Button>  </span>
                                    }
                                </Col>
                            </Row>
                        </Row>

                    </>
                }
            </Container>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
                <Dialog isOpen={isErrBox} onClose={(e) => setErrBox(false)}>
                    {errText}
                </Dialog>
            </div>
            <div>
                <Modal show={showModal} onHide={() => setShowModal(false)} animation={false} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Enter Date:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Form.Group>
                            <Form.Label>Source Transaction Date: {activityDate}</Form.Label>
                        </Form.Group>
                        &nbsp;
                        <Form.Group>
                            <Form.Label>Date<span className="colorThemeRed">*</span></Form.Label>
                            <DatePicker className="form-control"
                                selected={acceptIBDate}
                                onChange={(date) => setAcceptIBDate(date)}
                                minDate={new Date(startDate)}
                                maxDate={new Date(endDate)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>

                        {type === 'CNOUT' && <Row>
                            <Col className="col-md-10 col-6">
                                <Form.Label>Executive<span className="colorThemeRed">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={outCNExecutive}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchExecutivePicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleExecutiveChange}
                                    isDisabled={viewStatus != 'P'}
                                >
                                </AsyncSelect>
                            </Col>
                            {ndeliveryBy === 'A' ?
                                <Col className='col-md-10 col-6'>
                                    <Form.Group>
                                        <Form.Label>Shipment Number</Form.Label>
                                        <Form.Control type="text" maxLength={255} placeholder='Shipment Number' disabled={viewStatus != 'P'} value={shipmentNumber} onChange={e => setShipmentNumber(e.target.value)} />
                                    </Form.Group>
                                </Col> : null}
                        </Row>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => handleChanges()}>
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            {/* <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} /> */}

            <div>
            </div>
        </>
    )
}

export default Accept_interbranch
